'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { lenis } from '@/app/components/common/SmoothScroll/SmoothScroll';
import { usePathname } from 'next/navigation';
import { toggleSiteScroll } from '@/lib/utils';

const MenuContext = createContext(undefined);

export const MenuProvider = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    toggleSiteScroll(!isMenuOpen);
  };

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <MenuContext.Provider value={{ isMenuOpen, toggleMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
};

export default MenuContext;
